<template>
  <div id="iframe-menu" style="height: 100%;">
    <!-- <loading-gif :loadingShow="loading" :loadingBackgroundColor="loadingBackgroundColor" :loadingText="loadingText" /> -->
    <iframe v-if="linkUrl" webkitallowfullscreen="true" @load="loaded()" mozallowfullscreen="true" allowfullscreen="true"  :key="key" class="portal-iframe" :src="linkUrl" width="100%" height="99.5%" frameborder="0" id="portalInnerIframe"></iframe>
  </div>
</template>
<script>
import {on, off} from '@/assets/utils'
import queryString from 'querystring'
import {geipUrl} from '@/assets/js/config'
import { getCookie, deleteAllCookie } from '@/assets/utils/CommonUtil'
// import loadingGif from '_c/loading-gif'

let urlDomain = window.location.origin

export default {
  data () {
    return {
      key: Date.now(),
      linkUrl: '',
      loading: true,
      loadingBackgroundColor: '#FFFFFF',
      loadingText: '加载中…'
    }
  },
  components: {
    // loadingGif
  },
  created () {
    const geipToken = getCookie('GEIPTOKEN')
    const tenantId = getCookie('tenantId')
    if (geipToken === 'undefined' || !geipToken || tenantId === 'undefined' || !tenantId) {
      deleteAllCookie()
      window.location.href = `${urlDomain}`
    }
    this.setLinkUrl()
  },
  mounted () {
    // 给window对象绑定message事件处理
    on(window, 'message', this.handMessage)
  },
  beforeDestroy () {
    off(window, 'message', this.handMessage)
  },
  methods: {
    // 1. 设置iframe地址
    setLinkUrl () {
      this.linkUrl = ''
      const baseSingleUrl = `${geipUrl}/identification/productPage`
      const basePortalUrl = `${geipUrl}/portal/`
      const query = this.$route.query
      let { 
        menuCode = null, 
        path = null, 
        viewMode = 'full', 
        tenantId:tId, 
        local_token, 
        orgId,
        applicationCode ='zaojiayun',
        productCode = 'gccs_base-paas'
      } = this.$route.query

      const tenantId = getCookie('tenantId') || tId
      orgId = getCookie('orgId')
      const portalCode = {
        applicationCode, // 入口编码（可选，入口集成时必选，模块集成多入口有重复菜单时必选）
        productCode, // 产品编码,必选
        pageFrom: 'zjy',
        // menuCode, // 菜单编码,必选
        orgId, // 组织Id,必选，不加载组织树
        viewMode, // 显示模式,必选, module ：模块集成；application：应用入口集成；full: 完整版；singleModule: 单模块查看（有Header无菜单）
        tenantId, // 租户Id,可选,适用于多租户时直接进入某租户
        timestamp: this.key
        // path: '' // 带参数,可选；目标是微应用内部非默认页面时传入其路由path,path=encodeURIComponent（/detail/234324?a=1）

      }
      // 不传menuCode默认进入到第一个页签
      if (menuCode && menuCode !== 'home'){
        portalCode.menuCode = menuCode
      }
      const portalUrl = basePortalUrl + `?${queryString.encode(portalCode)}`
      const geipToken = getCookie('GEIPTOKEN')
      const productUrl = encodeURIComponent(portalUrl)
      let linkUrl = baseSingleUrl + `?tenantId=${tenantId}&token=${geipToken}&timestamp=${this.key}&pageFrom=zjy&productUrl=${productUrl}`
      this.linkUrl = linkUrl

      // if (this.$route.params && this.$route.params.name) {
      //   document.title = this.$route.params.name
      // }
      // let linkUrl = decodeURIComponent(this.$route.params.linkUrl)
      // const obj = {}
      // if (this.$route.query) {
      //   for (const key in this.$route.query) {
      //     if (!(['linkUrl'].includes(key))) {
      //       obj[key] = this.$route.query[key]
      //     }
      //   }
      // }
      // let index = linkUrl.indexOf('?')
      // if (index > -1) {
      //   // 2021.3.15 新增--开始
      //   // weburl中存在带#号，若有需要编码
      //   let queryParams = queryString.decode(linkUrl.substring(index + 1))
      //   if (queryParams.weburl && queryParams.weburl.indexOf('#') > -1) {
      //     linkUrl = `${linkUrl.substring(0, index)}?weburl=${encodeURIComponent(queryParams.weburl)}`
      //     delete queryParams.weburl
      //     for (let key in queryParams) {
      //       linkUrl += `&${key}=${queryParams[key]}`
      //     }
      //     // let weburl = `weburl=${encodeURIComponent(queryParams.weburl)}`
      //     // delete queryParams.weburl
      //     // linkUrl = `${linkUrl.substring(0, index)}?${weburl}&${queryString.stringify(queryParams)}`
      //   }
      //   // 2021.3.15 新增--结束
      //   linkUrl += '&'
      // } else {
      //   linkUrl += '?'
      // }
      // linkUrl += queryString.stringify(obj)
      // this.linkUrl = linkUrl
    },
    // iframe加载完成
    loaded () {
      this.loading = false
      // 判断是否已经刷新过页面
      // const hasReloaded = localStorage.getItem('hasReloaded')
      // if (hasReloaded) {
      //   setTimeout(() => {
      //     this.$nextTick(() => {
      //     // 刷新页面
      //     // 将标志设为 true，表示已刷新
      //       localStorage.removeItem('hasReloaded')
      //       location.reload(true)
      //     })
      //   }, 500)
      // }
    }
  },
  watch: {
    $route () {
      if (this.$route.params) {
        this.key = Date.now()
        // this.linkUrl = decodeURIComponent(this.$route.params.linkUrl)
        this.setLinkUrl()
        // this.setLeftMenus(this.$route)
      }
    },
    linkUrl: {
      handler (val, oldVal) {
        //   const hasReloaded = localStorage.getItem('hasReloaded')
        //   if (hasReloaded) {
        //     this.$nextTick(() => {
        //       setTimeout(() => {
        //       // 刷新页面
        //       // 将标志设为 true，表示已刷新
        //       localStorage.removeItem('hasReloaded')
        //       location.reload(true)
        // }, 500)
        //     })
        //   }
        // const iframePortal = document.getElementById('portalInnerIframe')
        // iframePortal && iframePortal.contentWindow.location.reload(true)
      },
      deep: true
    }
  }
}
</script>
<style>
  @import '~@/views/iframePortal/Index.less';
</style>
